// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Reports-Sales-ServedBy-__ServedBy___1aR8e","tableWrapper":"app-pages-Reports-Sales-ServedBy-__ServedBy___2LKnY","tableWrapperResponsive":"app-pages-Reports-Sales-ServedBy-__ServedBy___eMtKb"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Reports/Sales/ServedBy/ServedBy.css
// module id = 2492
// module chunks = 0